import React from "react";
import { CircularProgress, Box } from "@mui/material";
import { api } from "../../api/api";
import { IBrokerCode } from "../../redux/brokerCode/brokerCode.types";
import { ExtendableSelect } from "../formsComponents/ExtendableSelect";

export interface IBrokerCodeFieldProps {
  value: any;
  onChange: (newValue: string) => void;
  insurer?: string | null;
  branch_code?: string | null;
  error?: boolean;
  errorMessage?: string;
  placeholder?: string;
  disabled?: boolean;
  fullWidth?: boolean;
}

export const BrokerCodeField: React.FC<IBrokerCodeFieldProps> = (props) => {
  const {
    value,
    onChange,
    insurer,
    branch_code,
    error,
    errorMessage,
    placeholder,
    disabled,
    fullWidth,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [options, setOptions] = React.useState<
    { label: string; value: string }[]
  >([]);

  React.useEffect(() => {
    const fetchBrokerCodes = async () => {
      if (!insurer && !branch_code) {
        setOptions([]);
        return;
      }

      setLoading(true);
      try {
        let url = `/insurance/get-broker-code?status=ACTIVE`;
        if (insurer) {
          url += `&insurer_code=${insurer}`;
        }
        if (branch_code && branch_code !== "") {
          url += `&branch_office_code=${branch_code}`;
        }

        const res = await api.get(url);
        const data: IBrokerCode[] = res.data.data;
        const mapped = data.map((item) => ({
          label: item.broker_code,
          value: item.broker_code,
        }));
        setOptions(mapped);
      } catch (error) {
        console.error("Error fetching broker codes:", error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBrokerCodes();
  }, [insurer, branch_code]);

  return (
    <Box position="relative">
      <ExtendableSelect
        value={value}
        options={options}
        onChange={onChange}
        error={error}
        errorMessage={errorMessage}
        placeholder={placeholder || "Select One"}
        disabled={disabled || loading}
        fullWidth={fullWidth}
      />
      {loading && (
        <CircularProgress
          size={16}
          sx={{ position: "absolute", right: 36, top: "50%", marginTop: "-8px" }}
        />
      )}
    </Box>
  );
};
